import { About } from "@/features/About";

export default function AboutPage() {
  return <About />;
}
